<template>
  <div>
    <div class="process">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list module">
        <div>
          <div class="bg"></div>
          <div class="content">
            <div class="title">技术选型</div>
            <div class="line"></div>
            <div class="p">通过前期与客户进行充分的调研，臻图的项目专理会根据用户的建设目的、技术条件、环境限制、预算等向客户提供合理、高质量的技术架构选型方案。</div>
          </div>
        </div>
        <div>
          <div class="bg"></div>
          <div class="content">
            <div class="title">建设方案</div>
            <div class="line"></div>
            <div
              class="p"
            >基于对用户需求和分析确认，以及对项目的整体技术选型方案。与用户进一步沟通项目建设细节内容，确定系统功能，形成初步建设方案；基于用户的选择和意愿进行细节调整和修改，经过迭代，得到客户确认的最终方案。</div>
          </div>
        </div>
        <div>
          <div class="bg"></div>
          <div class="content">
            <div class="title">空间信息可视化分析设计</div>
            <div class="line"></div>
            <div
              class="p"
            >通过与客户的充分沟通，对设计对象的定位、理念、业务逻辑等各方面进行详尽、准确的了解，凭借丰富的行业软件实施经验，对多元异构数据源进行梳理，并通过专业的数据统计分析方法，结合行业应用决策模型，对空间信息数据按主题、成体系地进行数据呈现规划；并将各种类型的数据，通过丰富的展现形式进行可视化呈现，最终为客户提供辅助决策支持的系统分析设计。</div>
          </div>
        </div>
        <div>
          <div class="bg"></div>
          <div class="content">
            <div class="title">系统交互设计</div>
            <div class="line"></div>
            <div
              class="p"
            >设计师经过对设计对象的分析设计后，根据用户的使用情境量身定制一个适用的人机交互方案，包括功能流程设计、可视化页面设计等，为客户提供功能全面、快捷的解决方案。同时，我们试图在此基础上，凭借十几年的项目设计实施经验，帮助客户从更多新视角对核心业务作出更深层次的审视与理解。</div>
          </div>
        </div>
        <div>
          <div class="bg"></div>
          <div class="content">
            <div class="title">系统视觉设计</div>
            <div class="line"></div>
            <div
              class="p"
            >针对空间信息大数据可视化类项目，设计师会按照前期对设计对象的理解和把握，有效的把握设计对象的风格、色彩、标识、实用性和情感性等元素，并经过不断审查、实验和改进后最终形成设计方案。当视觉设计和交互设计确定之后，将所有的交互设计框图套入视觉设计的风格，完成所有要求的关键页面和标准页面，并在此基础上进行细节调整和修改，经过迭代，得到客户的最终确认。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-process">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="item">
          <div class="title">技术选型</div>
          <div class="item-container">
            <div class="content">
              通过前期与客户进行充分的调研，臻图的项目专理会根据用户的建设目的、技术条件、环境限制、预算等向客户提供合理、高质量的技术架构选型方案。
            </div>
            <img src="../assets/images/process/process1.jpg" style="width: 15rem; height: 15rem" alt="">
          </div>
          
        </div>
        <div class="item item1">
          <div class="title" style="text-align: right; ">建设方案</div>
          <div class="item-container">
            <img src="../assets/images/process/process2.jpg" style="width: 15rem; height: 15rem" alt="">
            <div class="content">
              基于对用户需求和分析确认，以及对项目的整体技术选型方案。与用户进一步沟通项目建设细节内容，确定系统功能，形成初步建设方案；基于用户的选择和意愿进行细节调整和修改，经过迭代，得到客户确认的最终方案。
            </div>
            
          </div>
          
        </div>
        <div class="item">
          <div class="title">空间信息可视化分析设计</div>
          <div class="item-container">
            <div class="content">
              通过与客户的充分沟通，对设计对象的定位、理念、业务逻辑等各方面进行详尽、准确的了解，凭借丰富的行业软件实施经验，对多元异构数据源进行梳理，并通过专业的数据统计分析方法，结合行业应用决策模型，对空间信息数据按主题、成体系地进行数据呈现规划；并将各种类型的数据，通过丰富的展现形式进行可视化呈现，最终为客户提供辅助决策支持的系统分析设计。
            </div>
            <img src="../assets/images/process/process3.jpg" style="width: 15rem; height: 15rem" alt="">
          </div>
        </div>
        <div class="item item1">
          <div class="title" style="text-align: right; ">系统交互设计</div>
          <div class="item-container">
            <img src="../assets/images/process/process4.jpg" style="width: 15rem; height: 15rem" alt="">
            <div class="content">
              设计师经过对设计对象的分析设计后，根据用户的使用情境量身定制一个适用的人机交互方案，包括功能流程设计、可视化页面设计等，为客户提供功能全面、快捷的解决方案。同时，我们试图在此基础上，凭借十几年的项目设计实施经验，帮助客户从更多新视角对核心业务作出更深层次的审视与理解。
            </div>
            
          </div>
          
        </div>
        <div class="item">
          <div class="title">系统视觉设计</div>
          <div class="item-container">
            <div class="content">
              针对空间信息大数据可视化类项目，设计师会按照前期对设计对象的理解和把握，有效的把握设计对象的风格、色彩、标识、实用性和情感性等元素，并经过不断审查、实验和改进后最终形成设计方案。当视觉设计和交互设计确定之后，将所有的交互设计框图套入视觉设计的风格，完成所有要求的关键页面和标准页面，并在此基础上进行细节调整和修改，经过迭代，得到客户的最终确认。
            </div>
            <img src="../assets/images/process/process5.jpg" style="width: 15rem; height: 15rem" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Process",
  data() {
    return {
      bannerData: {
        title: "服务流程",
        p: "臻图为用户打造专属的精准、有效的高品质方案，提供一站式服务"
      }
    };
  },
  methods: {},
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/other/header_bg.jpg");
}
.process {
  .list {
    margin: 0 auto 150px auto;
    > div {
      position: relative;
      margin-top: 140px;
      .content {
        width: 960px;
        height: 350px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 50px 10px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: inline-block;
        padding: 0 206px;
        box-sizing: border-box;
        text-align: left;
        .title {
          text-align: center;
          font-size: 30px;
          color: rgba(75, 75, 75, 1);
          line-height: 30px;
          margin-top: 50px;
        }
        .line {
          margin: 10px auto 30px auto;
          width: 40px;
          height: 2px;
          background: rgba(75, 75, 75, 1);
        }
        .p {
          font-size: 16px;
          color: rgba(124, 124, 124, 1);
          line-height: 32px;
        }
      }
      .bg {
        width: 350px;
        height: 350px;
        background: #ccc;
        position: absolute;
        top: -40px;
      }
      &:nth-child(1) {
        .bg {
          background: url("../assets/images/process/process1.jpg") no-repeat
            center center / 100% 100%;
        }
      }
      &:nth-child(2) {
        .bg {
          background: url("../assets/images/process/process2.jpg") no-repeat
            center center / 100% 100%;
        }
      }
      &:nth-child(3) {
        .bg {
          background: url("../assets/images/process/process3.jpg") no-repeat
            center center / 100% 100%;
        }
      }
      &:nth-child(4) {
        .bg {
          background: url("../assets/images/process/process4.jpg") no-repeat
            center center / 100% 100%;
        }
      }
      &:nth-child(5) {
        .bg {
          background: url("../assets/images/process/process5.jpg") no-repeat
            center center / 100% 100%;
        }
      }
      &:nth-child(2n + 1) {
        text-align: right;
      }
      &:nth-child(2n) {
        .bg {
          right: 0;
        }
      }
    }
  }
}
.mobile-process {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .list {
    width: 100%;
    .item {
      width: 100%;
      box-sizing: border-box;
      padding: 2.5rem 2rem;
      .title {
        width: 100%;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 2.5rem;
      }
      .item-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content {
          width: 17rem;
          font-size: 1rem;
          font-weight: 350;
          line-height: 2rem;
          margin-top: 1rem;
        }
      }
    }
    .item1 {
      background: rgba(0, 0, 0, 0.03);
    }
  }
}
@media (max-width: 1024px) {
  .process {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-process { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/process.vue